import PropTypes from 'prop-types';
import styled from 'styled-components';
import H6 from '@base/H6/H6';
import {
  Spacings,
  PRIMARY_BORDER_WIDTH,
  DASHED_BORDER_STYLE,
  TextColors
} from '@styles/index';

const StyH6 = styled(H6)`
  font-weight: bold;
  line-height: 100%;
  border-bottom-width: ${PRIMARY_BORDER_WIDTH};
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-style: ${DASHED_BORDER_STYLE};
  border-color: ${({ color }) => color};
  padding-bottom: ${Spacings.SPACING_6};
  width: fit-content;
  cursor: pointer;
`;

const doNothing = () => {};

const UnderlineButton = ({ color, onClick, label, disabled }) => (
  <StyH6 color={color} onClick={!disabled ? onClick : doNothing}>
    {label}
  </StyH6>
);

export default UnderlineButton;

UnderlineButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  label: PropTypes.string
};

UnderlineButton.defaultProps = {
  onClick: null,
  disabled: false,
  color: TextColors.BLUE,
  label: ''
};
